export default "__VITE_ASSET__CRIAoXkD__"